<template>
  <div class="filter-week-buttons-block">
    <ButtonWeekFilter :to="url" />
  </div>
</template>

<script setup>

import ButtonWeekFilter from "@/features/schedule/components/ButtonWeekFilter.vue";
import {computed, defineProps} from "vue";
import {useRoute} from "vue-router";
import {getAddress} from "@/data/helpers/address";
const props = defineProps({
  type: {
    type: Number,
    required: true,
  },
});
const route = useRoute();
const url = computed(() => {
  let type = props.type;

  // Проверяем, что type — число и в допустимом диапазоне
  if (typeof type !== 'number' || isNaN(type) || type < 1 || type > 5) {
    type = 1; // или другое значение по умолчанию
  }

  return getAddress(route, type);
});
</script>

<style lang="scss" scoped>
.filter-week-buttons-block{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 30px;
}
</style>